module.exports = __webpack_public_path__ + "img/reward.7ce02cc2.svg";